
import genaration from '../../utils/classname';
var listLess = {};
export var listClass = genaration(listLess, 'list');